'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Embed;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('shared/modules/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "embed",
    "code": "<iframe src='youtube' />",
    "caption": "Video caption."
  }
  For showing a video, or other embedded content. Accepts the
  following attributes:

  code - the embed code for the video (coming from youtube or vimeo)
  caption - an optional caption to show below the video
*/

function Embed(_ref) {
  var moduleClass = _ref.moduleClass,
      title = _ref.title,
      code = _ref.code,
      caption = _ref.caption;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-embed ' + moduleClass
    },
    (0, _utils.renderTitle)(title),
    _react2.default.createElement('div', {
      dangerouslySetInnerHTML: {
        __html: code
      }
    }),
    (0, _utils.renderCaption)(caption)
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Embed/Embed.jsx
// module id = 1155
// module chunks = 0